"use client";

import React, { useState, useEffect } from 'react';

interface SuccessBoxProps {
    bg?: string; 
    title: string;
    text: string;
    type?: "standart" | "full";
}

const SuccessBox: React.FC<SuccessBoxProps> = ({ bg, title, text, type }) => {
    const [count, setCount] = useState(0);
    const targetNumber = parseInt(title.replace(/\D/g, ''), 10); // Extract number from string

    useEffect(() => {
        let observer: IntersectionObserver;
        const element = document.querySelector(`#counter-${targetNumber}`);

        if (element) {
            observer = new IntersectionObserver(
                (entries) => {
                    if (entries[0].isIntersecting) {
                        let start = 0;
                        const duration = 200; // Animation duration in ms
                        const stepTime = Math.abs(Math.floor(duration / targetNumber));

                        const interval = setInterval(() => {
                            start += 1;
                            setCount(start);
                            if (start >= targetNumber) {
                                clearInterval(interval);
                            }
                        }, stepTime);
                    }
                },
                { threshold: 0.5 }
            );
            observer.observe(element);
        }

        return () => {
            if (observer) observer.disconnect();
        };
    }, [targetNumber]);

    if (type === 'standart') {
        return (
            <div
                id={`counter-${targetNumber}`}
                className="flex flex-col w-1/1 justify-end bg-white"
            >
                <p className="text-violet-600 text-[38px] font-bold leading-[126%] max-[576px]:text-[22px]">
                    {count}{title.includes('+') && ' +'}{title.includes('%') && ' %'}
                </p>
                <p className="font-normal text-violet-300 tracking-[0.01em] text-base max-[576px]:text-[12px]">{text}</p>
            </div>
        );
    } else {
        return (
            <div
                id={`counter-${targetNumber}`}
                className="flex flex-col w-1/1 justify-end min-h-[199px] p-[24px] bg-right-top bg-no-repeat border border-violet-50 rounded-3xl shadow-[0_8px_24px_0_rgba(0,0,0,0.1)] bg-white max-[576px]:p-[20px] max-[576px]:min-h-[139px] max-[576px]:bg-[length:110px_110px] "
                style={{ backgroundImage: `url(${bg})` }}
            >
                <p className="text-violet-600 text-[38px] font-bold leading-[126%] max-[576px]:text-[22px]">
                    {count}{title.includes('+') && ' +'}{title.includes('%') && ' %'}
                </p>
                <p className="font-normal text-violet-300 tracking-[0.01em] text-base max-[576px]:text-[12px]">{text}</p>
            </div>
        );
    }
};

export default SuccessBox;
